







import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Mutation, State } from 'vuex-class';

import { Address, Maintenancejob } from '@/models';
import { AppState } from '@/store/app/types';

import { v4 as uuidv4 } from 'uuid';

@Component
export default class ProgressButton extends Vue {
  @State('app') public appState: AppState;

  @Getter('app/hasBlockingRequests') public hasBlockingRequests: boolean;

  @Mutation('app/addRequest')
  public addRequest: (payload: {id: string, blocking: boolean}) => void;

  @Prop({ default: false }) public disabled!: boolean;

  public id: string;

  public timer: number = 0;
  public delay: number = 200;
  public prevent: boolean = false;

  public created() {
    this.id = uuidv4();
  }

  public inProgress() {
    // Does a request with this component ID exist in the App State Requests?
    return this.appState.requests.find(r => r.id === this.id);
  }

  public onClick() {
    if (this.inProgress()) {
      return;
    }

    clearTimeout(this.timer);
    this.prevent = true;
    // Emit dblclick event, so we can use @click in the parent
    this.$emit('click', this.id);

    // Create a new non-blocking request
    this.addRequest({
      id: this.id,
      blocking: false,
    });
  }
}
